<template>
  <div>
    <v-row class="pa-5">
      <!-- TODO uncomment when invoices handling is implemented -->
      <!-- <v-col :lg="cardSize" xl="3">
        <ProgressCard
            icon="receipt"
            iconColor="scaleOrange"
            :title="$t('book/building:common.finances')"
            progressValue="80"
            text="Lorem ipsum ..."
            btnColor="scaleOrange"
            :btnText="$t('book/building:building.page-content.progress-card.finance-btn')"
            @onClick="$router.push('/buildings/edit/' + $route.params.id + '#finances')"
        />
      </v-col> -->
      <v-col :lg="cardSize" xl="3">
        <ProgressCard
            icon="device_hub"
            :title="$t('common:facility_plural')"
            :progressValue="100"
            text=""
            :btnText="$t('buttons:add-specific', { specific: $t('common:facility')})"
            @onClick="$router.push(`/${$store.state.manager.bookModuleUrl}/facilities?building=${$route.params.id}`)"
            @clickedCard="$router.push(`/${$store.state.manager.bookModuleUrl}/buildings/edit/${$route.params.id}#facilities`)"
        />
      </v-col>
      <v-col :lg="cardSize" xl="3">
        <ProgressCard
            icon="group"
            :title="$t('common:role_plural')"
            :progressValue="100"
            text=""
            :btnText="$t('buttons:add-specific', { specific: $t('common:role')})"
            @onClick="addRole"
            @clickedCard="$router.push(`/${$store.state.manager.bookModuleUrl}/buildings/edit/${$route.params.id}#roles`)"
        />
      </v-col>

      <!-- Task List -->
      <TaskList
          ref="taskList"
          :headerTitle="$t('common:task-list')"
          hideHeaderBtn
          @clickedCard="goToTask"
          @updateData="updateTaskList"
          @acceptTask="acceptInvitation"
          @declineTask="declineInvitation"
          @startTask="showGPSPermission($event)"
          :sorts="taskListSorts"
          :filter="taskListFilter"
          :defaultDesc="true"
          defaultSortBy="finishedOn"
          defaultFilterBy="all"
      />

      <TwoButtonDialog
          ref="checkGPSPermission"
          :hide-button="true"
          :dialog-title="$t('common:gps-control')"
          :dialog-text="$t('book/building:building.page-content.gps-dialog')"
          :button1-text="$t('buttons:accept')"
          :button2-text="$t('buttons:decline')"
          @clickedButton1="checkUserLocation($event)"
          @clickedButton2="startProcessJob($event, false)"
      />
    </v-row>

    <div class="pa-3 mt-3">
      <h4 class="greyDark--text mb-0 mt-1 mr-1">{{ $t('common:activity_plural') }}</h4>
      <ScrollTimeLine
          ref="scrollTimeLine"
          :showFacilityName="true"
          @updateData="updateTimeLine"
      />
    </div>

    <ProcessResultDialog ref="processResultDialog"/>
    <ProcessShowDialog ref="processShowDialog"/>
  
  </div>
</template>

<script>

import EventLogService from "@/modules/book/services/eventlog-service";
import TaskListService from '@/modules/book/services/process/impl/task-list-service'
import ProcessJobService from '@/modules/book/services/process/impl/process-job-service'
import FacilityService from "@/modules/book/services/facility-service";

import DataUtils from "@/modules/core/services/data-utils";
import GPSUtils from "@/modules/core/services/gps-utils";
import Utils from "@/modules/core/services/utils";

import Facility from "@/modules/book/data/facility";

import ScrollTimeLine from "@/modules/book/components/ScrollTimeLine/ScrollTimeLine";
import ProgressCard from "@/modules/core/components/ProgressCard/ProgressCard";
import TaskList from "@/modules/book/components/TaskList/TaskList"
import ProcessResultDialog from "@/modules/book/components/Process/ProcessResultDialog"
import TwoButtonDialog from "@/modules/core/components/TwoButtonDialog/TwoButtonDialog";

import ProcessShowDialog from "@/modules/book/components/Process/ProcessShowDialog"

import {mapState} from 'vuex'
import TaskListUtils from "@/modules/book/services/task-list-utils";
import DocumentationService from "@/modules/core/services/documentation-service";
import Vue from "vue";
import DateUtils from "@/modules/core/services/date-utils";

export default {
  name: 'BuildingDashboardTab',
  components: {
    ProgressCard,
    ScrollTimeLine,
    TaskList,
    ProcessResultDialog,
    ProcessShowDialog,
    TwoButtonDialog
  },
  data() {
    return {
      comboBoxModel: null,
      taskList: {
        options: [],
        search: [],
        filter: null,
        period: null
      }
    }
  },
  computed: {
    // Helper-Class to correctly display cards when sidebars are closed or not
    cardSize() {
      // if both sidebars are fully opened, make card size bigger
      if(this.leftBuildingDrawer && this.rightBuildingDrawer) {
        return '6'
        // if both side bars are closed, make card size smaller
      } else if(!this.leftBuildingDrawer && !this.rightBuildingDrawer) {
        return '2'
      } else {
        return '4'
      }
    },

    taskListSorts() {
      return [
        {label: this.$t('common:date'), value: "finishedOn"},
        {label: this.$t('book/building:building.page-content.task-list.sorts.process-name'), value: "processName"},
        {label: this.$t('book/building:building.page-content.task-list.sorts.facility-name'), value: "facilityName"},
      ]
    },

    taskListFilter() {
      return [
        {label: this.$t('common:all'), value: 'all'},
        {label: this.$t('book/building:building.page-content.task-list.filter.open'), value: 'open'},
        {label: this.$t('book/building:building.page-content.task-list.filter.finished'), value: 'finishedProcess'}
      ]
    },

    ...mapState('book/layout', {
      leftBuildingDrawer: state => state.leftBuildingDrawer,
      rightBuildingDrawer: state => state.rightBuildingDrawer
    }),
  },
  methods: {
    goToTask(task) {
      // If task is of type result, open result dialog
      if(!task.isJob) {
        this.$refs.processResultDialog.openDialog(task)
      } else {
        this.$refs.processShowDialog.openDialog(task)
      }
    },

    updateTaskList(options, search, filter, period) {
      this.taskList.options = options;
      this.taskList.search = search;
      this.taskList.filter = filter;
      this.taskList.period = period;

      if(filter == 'all') {
        this.readTaskList(options, search, period)
      } else if(filter == 'open') {
        this.readOpenProcess(options, search, period)
      } else if(filter == 'finishedProcess') {
        this.readProcessFinished(options, search, period)
      }
    },

    readTaskList(options, search, period) {
      if(!search) search = '';
      this.$refs.taskList.loading = true;

      TaskListService.readPageableBuildingTaskListFromAPI(
        this.$route.params.id,
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        period,
        (res) => {
          res.data.taskItems.content.forEach((task) => {
            task.taskStatus = TaskListUtils.getTaskStatus(task);
          })
          this.$refs.taskList.users = res.data.users;
          this.$refs.taskList.fillList(res.data.taskItems)
        },
        (error) => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:task-list')}))
          this.$logger.error(error);
        }
      )
    },

    readOpenProcess(options, search, period) {
      if(!search) search = '';

      TaskListService.readPageableBuildingOpenTaskListFromAPI(
        this.$route.params.id,
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        period,
        (res) => {
          res.data.taskItems.content.forEach((task) => {
            task.taskStatus = TaskListUtils.getTaskStatus(task);
          })
          this.$refs.taskList.users = res.data.users;
          this.$refs.taskList.fillList(res.data.taskItems)
        },
        (error) => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:task-list')}))
          this.$logger.error(error);
        }
      )
    },

    readProcessFinished(options, search, period) {
      if(!search) search = '';
      this.$refs.taskList.loading = true;

      TaskListService.readPageableBuildingProcessFinishedFromAPI(
        this.$route.params.id,
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        period,
        (res) => {
          res.data.taskItems.content.forEach((task) => {
            task.taskStatus = TaskListUtils.getTaskStatus(task);
          })
          this.$refs.taskList.users = res.data.users;
          this.$refs.taskList.fillList(res.data.taskItems)
        },
        (error) => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:task-list')}))
          this.$logger.error(error);
        }
      )
    },

    startProcessJob(item, gpsCheck) {
      // TODO save users decicion on GPS Check in backend
      if(gpsCheck) {
        this.acceptedGPSCheck = true;
      } else {
        this.acceptedGPSCheck = false;
      }

      ProcessJobService.startProcessJob(item.id, this.acceptedGPSCheck,
        () => {
          this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/process/${item.id}`);
        },
        (error) => {
          this.$logger.info("Error at starting Process Job: " + error);
        }
      )
    },

    showGPSPermission(item) {
      this.$refs.checkGPSPermission.showDialog = true;
      this.$refs.checkGPSPermission.propToGiveThrough = item;
      this.$store.commit("book/process/storeRideCount", null);
      this.$store.commit("book/process/storeFileNumber", null);
    },

    checkUserLocation(item) {
      FacilityService.readFromAPI(item.facility,
        (resp) => {
          var response = DataUtils.parseDataToSingleObject(resp.data, Facility);
          var buildingLat = response.buildingLatitude;
          var buildingLng = response.buildingLongitude;

          this.$getLocation({
            enableHighAccuracy: true,
          }).then(coordinates => {
              var userLat = coordinates.lat;
              var userLng = coordinates.lng;

              var distance = GPSUtils.calcDistance(userLat, userLng, buildingLat, buildingLng);
              if(distance == -1){
                Utils.showFailureSnackbar(this.$t('utils:gps.missing-value'))
              }
              if(distance < process.env.VUE_APP_CHECK_IN_LOCATION_RADIUS) {
                this.startProcessJob(item, true);
              } else {
                this.$refs.checkGPSPermission.showDialog = false;
                Utils.showFailureSnackbar(this.$t('utils:gps.distance-error'))
              }
          }).catch((error) => {
            this.$logger.info("Could not access GPS data, because: " + error);
            Utils.showFailureSnackbar(this.$t('utils:gps.access-error'))
          });
        }
      )
    },

    acceptInvitation(item) {
      if(item.isJob) {
        ProcessJobService.acceptProcessJob(item.id,
          () => {
            this.updateTaskList(this.taskList.options, this.taskList.search, this.taskList.filter, this.taskList.period);
            Utils.showSuccessSnackbar(this.$t('book/building:building.page-content.task-list.snackbar.accept-process'));
          },
          (error) => {
            this.$logger.info("Error at accepting Process Job: " + error);
          }
        )
      }
    },

    declineInvitation(item) {
      if(item.isJob) {
        ProcessJobService.rejectProcessJob(item.id,
          () => {
            this.updateTaskList(this.taskList.options, this.taskList.search, this.taskList.filter, this.taskList.period);
            Utils.showSuccessSnackbar(this.$t('book/building:building.page-content.task-list.snackbar.reject-process'));
          },
          (error) => {
            this.$logger.info("Error at rejecting Process Job: " + error);
          }
        )
      }
    },

    addRole() {
      this.$emit('addRole');
    },

    updateTimeLine(options, category) {
      if (!category) category = '';

      EventLogService.readPageableEventLogsByBuilding(
          this.$route.params.id,
          category,
          options.page - 1,
          options.itemsPerPage,
          "",
          options.sort,
          options.sortAsc,
          (res) => {
            res.data.content.forEach((log) => {
              let facilityId = log.facilityId;
              if (log.documentations.length > 0) {
                log.isImageActivity = true;

                DocumentationService.readInfoListFromApi(log.documentations,
                    (res) => {
                      log.documentations = res.data;

                      for (let docu of log.documentations) {
                        DocumentationService.getDocByTypeAndId(
                            docu.id,
                            docu.fileType,
                            docu.documentType,
                            facilityId,
                            (docuFile) => {
                              docu.formattedSavedOn = DateUtils.parseDateTimeForDisplay(docu.savedOn);
                              Vue.set(docu, "src", docuFile)
                            }
                        )
                      }
                    },
                    (error) => {
                      this.$logger.error("Failed loading documentations log " + log.id +", because: " + error);
                      Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:documentation_plural')}));
                    }
                )
              }
            })

            this.$refs.scrollTimeLine.fillTimeLine(res.data)
          }
      )
    }
  }
}
</script>
